import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthenticationDomainService } from '../../domain/services/authentication/authentication.domain.service';
import { JwtDecoded } from '../../domain/models/authentication/jwt-decoded';
import { RequestResult } from '../../domain/models';
import { LoginViewModel } from '../view-models/login.view-model';

@Injectable()
export class LoginService {
    constructor(private authenticationDomainService: AuthenticationDomainService) { }

    public login(loginVm: LoginViewModel): Observable<RequestResult<void>> {
        return this.authenticationDomainService.login(loginVm.email, loginVm.password);
    }

    public getDecodedAccessToken(): JwtDecoded {
        return this.authenticationDomainService.getDecodedAccessToken();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/login/services/login.service.ts